// src/storage/StorageContext.tsx
import React, { createContext, ReactNode, useContext } from 'react';
import { StorageAPI } from './StorageAPI';
import { DexieStorage } from './DexieStorage';

// Single Dexie instance
const storage = new DexieStorage();

// Context holding your StorageAPI
const StorageContext = createContext<StorageAPI>(storage);

// Hook for easy access
export function useStorage(): StorageAPI {
  return useContext(StorageContext);
}

// Props for the provider
interface StorageProviderProps {
  children: ReactNode;
}

// Function‐style provider (TSX file, so this JSX is allowed)
export function StorageProvider({ children }: StorageProviderProps) {
  return (
    <StorageContext.Provider value={storage}>
      {children}
    </StorageContext.Provider>
  );
}
